import { useRef } from "react";
import { message } from "antd";
import { v4 as uuidv4 } from "uuid";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import {
  getProductsNearbyStockService,
  upsertGiftCardTransaction,
  upsertCreditTransaction,
  upsertWalletTransactionService,
  discardCouponService,
  upsertCart,
  cartHistory,
} from "../../../../services";
import sortBy from "lodash/sortBy";
import db from "../../../../database";
import dayjs from "dayjs";
import openDrawer from "../../../../lib/printer/openDrawer";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useCartStore from "../../../../stores/useCartStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useSessionStore from "../../../../stores/useSessionStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import useAuthStore from "../../../../stores/useAuthStore";
import { generateDocumentNo } from "../../../../utils/documentSequenceUtils";

const useSuperMarketHandlers = ({
  cart,
  setCart,
  tillData,
  posConfig,
  pricePrecision,
  orderType,
  documentSequence,
  setDocumnetSequence,
  deleteCart,
  setGiftCardData,
  giftCardData,
  selectedProductInCart,
  setStockList,
  handleLoyaltyPayment,
  getFilteredPaymentMethods,
  setShowPayments,
  setSelectedDocumentType,
  searchInputRef,
  setShowInputFields,
  setCustomMixItems,
  setGroupQty,
  setActiveInput,
  setProductSearchInput,
  discardGiftCards,
  removeCutomer,
  upsertPOSLog,
  posConfigData,
  domainURL,
  selectedSaleTypeData,
  setIsNriBilling,
  setIsPanCustomer,
  hasShownCustomerModalRef,
  selectedCustomer,
  setSelectedCustomer,
  getCurrentMonthRange,
  setAmount,
  isExchange,
  syncOrders,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const authHeaders = getOAuthHeaders();
  const deletePaymentInFlightRef = useRef(false);

  const getProductNearByStock = async () => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    try {
      const stockInputValues = {
        query: `
        query {
          getProductsNearbyStock(
            bUnitId: "${tillData.tillAccess.csBunit.csBunitId}",
            code: "${selectedProductInCart.value}"
          ) {
            csBunitId
            value
            name
            totalQty
            stores {
              csNearbyStoreId
              name
              nearbybUnitId
              viewStock
              isIssue
              warehouse {
                mWarehouseID
                name
                value
                storageBin {
                  mStoragebinID
                  name
                  stocks {
                    mStockID
                    qtyonhand
                    product {
                      mProductId
                      value
                      name
                      upc
                      uom {
                        csUomId
                        name
                      }
                      productCategory {
                        mProductCategoryId
                        value
                        name
                      }
                    }
                    batch {
                      mBatchId
                      batchno
                      upc
                      price
                      startdate
                      enddate
                      life
                      purchasePrice
                      listPrice
                      purchaseDate
                    }
                  }
                  totalQty
                }
              }
            }
          }
        }
      `,
      };

      const response = await getProductsNearbyStockService(stockInputValues);

      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;

      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: "79FD0E516E4F4C5F9A7932F0C5C82C92",
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: {
            mStoragebinID: "09581CA09C154830A20B88370C501FD6",
            name: "Central Warehouse",
            stocks: [],
            totalQty: totalQty || 0,
          },
        },
      };

      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
    }
  };

  // Always reset return+exchange state on cancel — fixes issue where Cancel
  // button left exchangeCart and selectedReturnType=EXCHANGE in place, leaking
  // into the next bill.
  const clearReturnExchangeState = () => {
    useCartStore.getState().setExchangeCart(null);
    useTransactionStore.getState().setSelectedReturnType(null);
    useTransactionStore.getState().setReturnThisReceipt(null);
    useTransactionStore.getState().setRefundReturnCustomerId(null);
  };

  const cancelOrder = async () => {
    const isExchangeMode = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
    const exchangeCartObj = isExchangeMode ? useCartStore.getState().exchangeCart : null;
    const currentCart = isExchangeMode && exchangeCartObj?.items?.length > 0 ? exchangeCartObj : useCartStore.getState().cart;
    if (posConfig?.saveParkedBills === "Y" && currentCart?.isRetrived === "Y") {
      const csBunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const cwrPosCartId = currentCart?.cwr_pos_cart_id || null;
      const cwrTillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
      const status = "CL";

      const cartItems = currentCart;

      const cartPayload = {
        csBunitId,
        cwrPosCartId,
        cwrTillId,
        status,
        cartItems,
      };

      const response = await upsertCart(cartPayload);
      if (response?.status === 200) {
        if (response?.data?.data?.upsertCart?.status === "200") {
          // clearCart(cart.type);
          deleteCart();
          clearReturnExchangeState();
          setIsNriBilling(false);
          setIsPanCustomer(false);
          setSelectedDocumentType("Invoice");
          setShowInputFields(false);
          useTransactionStore.getState().setIsB2bEnabled(null);
          localStorage.removeItem("isB2bEnabled");
          localStorage.removeItem("customerAddressIds");
          localStorage.removeItem("isCreditSale");
          useTransactionStore.getState().setIsCreditSale(null);
          hasShownCustomerModalRef.current = false;
          if (searchInputRef?.current) {
            searchInputRef.current.focus();
          }
        }
      } else {
        message.warning("Something is wrong in upsertCart service");
      }
    } else if (posConfig?.saveCancelledOrders !== "Y") {
      deleteCart();
      clearReturnExchangeState();
      setIsNriBilling(false);
      setIsPanCustomer(false);
      setSelectedDocumentType("Invoice");
      setShowInputFields(false);
      useTransactionStore.getState().setIsB2bEnabled(null);
      localStorage.removeItem("isB2bEnabled");
      localStorage.removeItem("customerAddressIds");
      localStorage.removeItem("isCreditSale");
      useTransactionStore.getState().setIsCreditSale(null);
      hasShownCustomerModalRef.current = false;
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
    } else {
      let setAuthTokens;
      setSelectedDocumentType("Invoice");
      let PaymentMethods = getFilteredPaymentMethods() || [];
      let payments =
        PaymentMethods.length > 5
          ? sortBy(PaymentMethods, "sequenceNo").slice(
              0,
              tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5
                ? 5
                : cart.layAway === "Y" || cart?.creditSale === "Y"
                  ? 4
                  : 5
            )
          : PaymentMethods;

      setShowPayments(payments);
      if (authHeaders && authHeaders.access_token) {
        setAuthTokens = authHeaders.access_token;
      }
      if (cart?.couponInput?.length > 0) {
        const serverUrl = process.env.REACT_APP_serverUrl;

        const couponsData = [...cart.couponInput];
        // Function to discard a coupon
        const discardCoupon = async (coupon) => {
          const discardCouponQuery = {
            query: `query {
                  discardCoupon(couponcode: "${coupon.couponCode}", referenceId: "${coupon.referenceId}") {
                    status
                    message
                  }
                }`,
          };
          try {
            const response = await discardCouponService(coupon.couponCode, coupon.referenceId);

            console.debug(`Coupon ${coupon.couponCode} discarded:`, response.data);
          } catch (error) {
            console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
          }
        };
        couponsData.forEach((coupon) => {
          discardCoupon(coupon);
        });
      }

      discardGiftCards(cart);
      let index = cart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !cart.isReturn);
      if (index >= 0) {
        handleLoyaltyPayment(cart.payments[index], cart);
      }
      clearCart(cart.type);
      setSelectedDocumentType("Invoice");
      setIsNriBilling(false);
      setIsPanCustomer(false);
      useTransactionStore.getState().setIsB2bEnabled(null);
      localStorage.removeItem("isB2bEnabled");
      localStorage.removeItem("customerAddressIds");
      localStorage.removeItem("isCreditSale");
      hasShownCustomerModalRef.current = false;
      useTransactionStore.getState().setCouponAdditionalInfo(null);
      useCartStore.getState().setExchangeCart(null);
      useTransactionStore.getState().setIsCreditSale(null);
      useTransactionStore.getState().setReturnThisReceipt(null);
      setShowInputFields(false);
      setCustomMixItems([]);
      setGroupQty(1);
      setActiveInput("search");
      setProductSearchInput("");
      if (searchInputRef?.current) {
        searchInputRef.current.focus();
      }
    }
  };

  const handleDeletePayment = (payment) => {
    if (deletePaymentInFlightRef.current) return;
    deletePaymentInFlightRef.current = true;
    let activeCart = isExchange ? { ...(useCartStore.getState().exchangeCart || {}) } : { ...useCartStore.getState().cart };
    let paid = 0;
    Promise.all(
      activeCart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment?.finPaymentmethodId === pay?.finPaymentmethodId) {
          let setAuthTokens;
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: activeCart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));

          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
          cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
          type: "${detail.type}",
          referenceNo: "${detail.referenceNo}",
          amount: ${detail.amount},
          cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
          tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
          b2c_Customer_Id: ${activeCart.customer.cwrCustomerId ? `"${activeCart.customer.cwrCustomerId}"` : null}
        }`
          );

          const data = {
            query: `
              mutation {
                upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                  status
                  message
                }
              }`,
          };

          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "credit" && payment?.finPaymentmethodId === pay?.finPaymentmethodId) {
          const trxData = [
            {
              b2cCustomerId: activeCart?.customer?.cwrCustomerId,
              trxDate: dayjs(new Date()).format("YYYY-MM-DD"),
              trxAmt: Number(payment.amount),
              openingAmt: activeCart?.customer?.creditBalance - Number(payment.amount),
              closingAmt: activeCart?.customer?.creditBalance,
              type: "CR",
              cwrTillId: null,
              sOrderId: null,
              referenceNo: activeCart?.referenceId,
            },
          ];
          const creditUpsertResponse = await upsertCreditTransaction(trxData);
        } else if (payment.name.toLowerCase() === "loyalty" && payment?.finPaymentmethodId === pay?.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, activeCart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.isWallet === "Y" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          try {
            const tillData = useAuthStore.getState().tillData || {};
            const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;

            const refundAmount = Number(payment.amount);

            const payload = {
              bunitId,
              customerId: activeCart.customer.cwrCustomerId,
              trxType: "DP", // Deposit back
              trxValue: refundAmount,
              tillId: tillData?.tillAccess.cwrTill.cwrTillID,
              payments: [],
              transactionDetails: "{}",
            };

            const response = await upsertWalletTransactionService(payload);

            if (response?.status === "200") {
              const updatedCustomer = {
                ...selectedCustomer[0],
                currentBalance: (selectedCustomer[0]?.currentBalance || 0) + refundAmount,
              };

              setSelectedCustomer([updatedCustomer]);
              message.success("Wallet amount refunded");
            } else {
              message.error("Wallet refund failed");
            }
          } catch (err) {
            console.error("Wallet refund error", err);
          }
        }
      })
    )
      .then((results) => {
        activeCart.payments = results.filter((result) => result !== undefined);
        activeCart.paid = paid + (activeCart?.advancePayment || 0);
        setAmount(parseFloat((activeCart.total - activeCart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          activeCart.tenderedAmount = activeCart.tenderedAmount - payment.amount;
        } else if (payment?.name?.toLowerCase() === "gift card") {
          activeCart.giftCardNumbers = [];
        }
        if (isExchange) {
          useCartStore.getState().setExchangeCart(activeCart);
        } else {
          setCart(activeCart);
        }
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      })
      .finally(() => {
        deletePaymentInFlightRef.current = false;
      });
  };

  const clearCart = async (type) => {
    const tillSession = useSessionStore.getState().tillSession;
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" ? documentSequence : documentSequence + 1;
    let cartToDb = JSON.parse(JSON.stringify(cart)); // DEEP copy to avoid any reference issues
    cartToDb.orderTime = dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = dayjs(new Date()).format("DD-MM-YYYY");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart?.customer?.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.paid = 0; // <-- FIX: ensure paid is 0 for cancelled order
    cartToDb.payments = []; // <-- FIX: ensure payments is empty for cancelled order
    cartToDb.change = 0; // <-- FIX: ensure change is 0
    const resetItemValues = (item) => {
      item.realWeight = item.weight;
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((child) => resetItemValues(child));
      }
    };
    cartToDb.items.forEach((item) => resetItemValues(item));
    if (type === "Layaway") {
      const cancelledSeqLW = useSessionStore.getState().cancelledOrderSequence;
      if (cancelledSeqLW) {
        cartToDb.documentno = generateDocumentNo(cancelledSeqLW);
        useSessionStore.getState().incrementCancelledOrderSequence();
        deleteCart(true, "ownSequence");
      } else {
        deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
      }
      await db.orders.put(cartToDb);
      if (posConfig?.disableOfflineBilling === "Y") {
        syncOrders("auto");
      }
    } else {
      const cancelledSeq = useSessionStore.getState().cancelledOrderSequence;
      if (cancelledSeq) {
        cartToDb.documentno = generateDocumentNo(cancelledSeq);
        useSessionStore.getState().incrementCancelledOrderSequence();
        deleteCart(true, "ownSequence");
      } else {
        useSessionStore.getState().setDocumentSequence(newDocumentSequence);
        setDocumnetSequence(newDocumentSequence);
        deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
      }
    }
    // Persist and sync the cancelled-order snapshot regardless of type — this ran
    // unconditionally before the cancelled-sequence feature was added; a later
    // refactor accidentally nested it inside the non-Layaway branch only, which
    // silently dropped the cancel record (and its server sync) for Layaway/Advance
    // cancellations.
    await db.orders.put(cartToDb);
    if (posConfig?.disableOfflineBilling === "Y") {
      syncOrders("auto");
    }
    useTransactionStore.getState().setSelectedReturnType(null);
    setGiftCardData([]);
  };

  const handleLogout = async (setLogoutLoading) => {
    setLogoutLoading(true);
    let parkedBills = useSessionStore.getState().parkedList;
    let posConfig = usePOSConfigStore.getState().posConfig;
    if (posConfig?.saveParkedBills === "Y") {
      try {
        const dateRange = getCurrentMonthRange();

        const filterBy = JSON.stringify({
          DateRange: dateRange,
        });

        const sortBy = JSON.stringify({
          created: "DESC",
        });

        const response = await cartHistory({
          q: "",
          filter_by: filterBy,
          sort_by: sortBy,
          tillId: tillData?.tillAccess?.cwrTill?.cwrTillID || null,
        });

        if (response?.status === 200) {
          const data = JSON.parse(response?.data?.data?.cartHistory || "[]");

          const parkedBillsFromAPI = data.filter((item) => item?.cartstatus === "DR");

          if (parkedBillsFromAPI.length > 0) {
            message.error(`${t("unlink_till_parked_bill_error")}`);
            setLogoutLoading(false);
            return;
          }
        }
      } catch (error) {
        console.error("Error checking parked bills:", error);
        setLogoutLoading(false);
        return;
      }
    } else {
      if (parkedBills?.length > 0) {
        message.error(`${t("unlink_till_parked_bill_error")}`);
        setLogoutLoading(false);
        return;
      }
    }

    if (cart?.items?.length > 0) {
      {
        message.error(`${t("unlink_till_cart_error")}`);
      }
      setLogoutLoading(false);
    } else {
      if (posConfigData?.posType === "PRD") {
        const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
        for (let i = 0; i < cookiesToDelete.length; i++) {
          const cookie = cookiesToDelete[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          const domain = "domain=" + domainURL;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
        }
        useSessionStore.getState().setTillSession(null);
        window.location.assign("/");
        setLogoutLoading(false);
      } else {
        removeCutomer();
        openDrawer();
        upsertPOSLog(cart, "LGO");
        useSessionStore.getState().setLocked(false);
        if (posConfig?.shiftClose === "Y") {
          // Close-till flow: count cash → reconcile → close → sign-in
          history.push("/close-till");
        } else {
          // No shift close: clear auth, go to sign-in for next cashier
          const cookiesToDelete = document.cookie.split(";").map((c) => c.trim());
          for (const c of cookiesToDelete) {
            const name = c.split("=")[0];
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domainURL}`;
          }
          useSessionStore.getState().setTillSession(null);
          useAuthStore.getState().logout();
          window.electronAPI?.auth?.logout();
          window.location.assign("/sign-in");
        }
        setLogoutLoading(false);
      }
    }
  };

  return {
    getProductNearByStock,
    cancelOrder,
    handleDeletePayment,
    clearCart,
    handleLogout,
  };
};

export default useSuperMarketHandlers;
